module.exports = __webpack_public_path__ + "static/img/wcaLight.19cbeab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wcaLight.png
// module id = 1deW
// module chunks = 3